import Marquee from "react-fast-marquee";

const WORDS = ["Sound", "Production", "Catalogue", "Creative Direction", "Artist Development", "Career Development"];

export const MarqueeStrip = () => {
  return (
    <section className="relative py-16 lg:py-24 bg-[#050505] overflow-hidden" data-testid="marquee-section">
      <Marquee speed={40} gradient gradientColor="#050505" gradientWidth={160} autoFill>
        {WORDS.map((w, i) => (
          <span key={i} className="mx-8 flex items-center gap-8">
            <span className="font-heading uppercase tracking-tight text-6xl lg:text-8xl text-outline">{w}</span>
            <span className="w-3 h-3 rounded-full bg-white/30" />
          </span>
        ))}
      </Marquee>
    </section>
  );
};

export default MarqueeStrip;
